import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createLlmProfile } from '@/lib/api/generated/api';

import { toLlmProfileError } from '../errors';
import { llmProfileKeys } from '../queryKeys';
import type { LlmProfile, LlmProfileWriteInput } from '../types';

/** Create a new LLM profile for the organization. */
export function useCreateLlmProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      body: LlmProfileWriteInput & { slug: string },
    ): Promise<LlmProfile> => {
      const response = await createLlmProfile(body);
      if (response.status === 201) return response.data;
      throw toLlmProfileError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: llmProfileKeys.all() });
    },
  });
}
